import styled, { css } from 'styled-components';

import Link from 'Elements/Link';

export const StyledLink = styled(Link)`
    ${({ theme }) => css`
        font-weight: bold;
        text-align: center;

        margin: 0 0.25rem;

        &:after {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            bottom: 0;
        }

        @media ${theme.breakpoints.medium.media} {
            margin: 0 1.5rem;
        }
    `}
`;

export const LinkWrapper = styled.div<{ $numberOfItems: number }>`
    ${({ $numberOfItems }) => css`
        width: ${`${100 / $numberOfItems}%`};
        display: flex;
        justify-content: center;
    `}
`;

export const Wrapper = styled.div`
    position: relative;
    overflow-x: hidden;
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        text-align: center;
        font-family: ${theme.fonts.secondary};
        font-weight: 300;
        margin-bottom: 1.5rem;

        @media ${theme.breakpoints.medium.media} {
            margin-bottom: 2.5rem;
        }
    `}
`;

export const Container = styled.nav`
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-evenly;
`;

export const Icon = styled.svg<{ $color: string }>`
    ${({ $color, theme }) => css`
        width: 1.25rem;
        height: 1.25rem;
        color: ${$color};
        stroke-width: 0.125rem;
        transition: all ease 0.25s;

        @media ${theme.breakpoints.smallLarge.media} {
            width: 1.75rem;
            height: 1.75rem;
        }
    `}
`;

export const IconWrapper = styled.div<{ $backgroundColor: string; $border: boolean }>`
    ${({ $backgroundColor, $border, theme }) => css`
        width: 2.5rem;
        height: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background-color: ${$backgroundColor};
        transition: all ease 0.5s;
        margin-bottom: 0.75rem;

        ${$border &&
        css`
            border: 0.125rem solid ${theme.colors.secondary.tints[2].hex};
        `}

        @media ${theme.breakpoints.smallLarge.media} {
            width: 4rem;
            height: 4rem;
        }
    `}
`;

export const HorizontalProgressBar = styled.div<{ $progress: number; $numberOfItems: number }>`
    ${({ theme, $progress, $numberOfItems }) => css`
        position: absolute;
        width: 100%;
        height: 0.25rem;
        background: ${`linear-gradient(to right, ${theme.colors.secondary.tints[11].hex} ${
            (100 / $numberOfItems) * $progress - 50 / $numberOfItems
        }%, ${theme.colors.secondary.tints[1].hex} ${
            (100 / $numberOfItems) * $progress - 50 / $numberOfItems
        }%)`};
        z-index: -1;
        top: 1.1rem;

        ${$numberOfItems === $progress &&
        css`
            background: ${theme.colors.secondary.tints[11].hex};
        `}

        @media ${theme.breakpoints.smallLarge.media} {
            height: 0.5rem;
            top: 1.8rem;
        }

        &:before {
            content: '';
            position: absolute;
            top: 0;
            right: 100%;
            height: 100%;
            width: 50vw;
            background: ${theme.colors.secondary.tints[11].hex};
        }

        &:after {
            content: '';
            position: absolute;
            top: 0;
            left: 100%;
            height: 100%;
            width: 50vw;
            background: ${$progress === $numberOfItems
                ? theme.colors.secondary.tints[11].hex
                : theme.colors.secondary.tints[1].hex};
        }
        ${$numberOfItems === $progress &&
        css`
            background: ${theme.colors.secondary.tints[11].hex};
        `}
    `}
`;

export const InteractionWrapper = styled.div<{ $border: boolean }>`
    ${({ theme, $border }) => css`
        position: relative;
        display: inline-flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        :hover {
            ${$border &&
            css`
                ${IconWrapper} {
                    background-color: ${theme.colors.secondary.tints[1].hex};
                    border: 0.125rem solid ${theme.colors.accents[5].hex};
                }
            `}
            ${Icon} {
                transform: scale(1.1);
            }
        }
    `}
`;
